import { cn } from "ui";
import { SkeletonButton } from "./SkeletonButton";

type SkeletonButtonGroupProps = {
  /** Number of button placeholders. */
  count?: number;
  /** Classes for the group wrapper. */
  className?: string;
};

export const SkeletonButtonGroup = ({
  count = 3,
  className,
}: SkeletonButtonGroupProps) => (
  <div className={cn("flex items-center gap-2", className)}>
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonButton key={i} />
    ))}
  </div>
);
